<template>
  <ListingBlockLayout title="Book Categories" class="tags-block-skeleton">
    <TagCardSkeleton
      v-for="i in numberOfCardsToRender"
      :key="i"
      :class="i > numberOfCardsToHideDesktop && 'skeleton-tag--hide-desktop'"
    />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import TagCardSkeleton from '@/app/components/listing/skeleton-loaders/TagCardSkeleton.vue'

const numberOfCardsToRender = 12
const numberOfCardsToHideDesktop = 6
</script>

<style lang="scss" scoped>
.tags-block-skeleton {
  --listing-block-number-of-columns: 6;
}

:deep(.listing-block__inner) {
  padding-bottom: 70px;

  @media only screen and (max-width: $w-tablet-s) {
    display: grid;
    grid-template-columns: repeat(
      var(--listing-block-number-of-columns),
      140px
    );
    gap: 8px;
    padding-bottom: 0;
  }
}

.skeleton-tag--hide-desktop {
  display: none;
  @media only screen and (max-width: $w-tablet-s) {
    display: block;
  }
}
</style>
